export default __webpack_public_path__ + "static/media/logo-hub-dark.d952042b.svg";